import React from "react";
import { useTranslation } from "react-i18next";
import { AVATARS, getAvatarUrl } from "../constants";
import styles from "../OnboardingWizard.module.scss";

interface Props {
  value: string;
  onChange: (avatarUrl: string) => void;
}

const AvatarStep: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.stepContent}>
      <h2 className={styles.stepTitle}>{t("onboarding.avatarTitle")}</h2>
      <p className={styles.stepSubtitle}>{t("onboarding.avatarSubtitle")}</p>

      <div className={styles.avatarGrid}>
        {AVATARS.map((name) => {
          const url = getAvatarUrl(name);
          const selected = value === url;
          return (
            <button
              key={name}
              type="button"
              className={`${styles.avatarItem} ${selected ? styles.avatarSelected : ""}`}
              onClick={() => onChange(url)}
            >
              <img src={url} alt={name} className={styles.avatarImage} />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default AvatarStep;
